import type { AppId } from "../../app-catalog";
import type { OrgRoleName } from "../../auth/permissions";
import type { EnabledOrgRoles } from "../../role-catalog";
import type { OrgRolePermissions } from "../../permission-catalog";
import { OrgRoleListPanel } from "./OrgRoleListPanel";
import { OrgRolePermissionsPanel } from "./OrgRolePermissionsPanel";

export interface OrgRolePermissionsSectionProps {
  enabledOrgRoles: EnabledOrgRoles;
  enabledApps?: AppId[];
  rolePermissions: OrgRolePermissions;
  selectedRoleKey: OrgRoleName | null;
  onSelectRoleKey: (roleKey: OrgRoleName) => void;
  onChange: (next: OrgRolePermissions) => void;
  manageAvailability?: boolean;
  onEnabledRolesChange?: (next: EnabledOrgRoles) => void;
}

export function OrgRolePermissionsSection({
  enabledOrgRoles,
  enabledApps,
  rolePermissions,
  selectedRoleKey,
  onSelectRoleKey,
  onChange,
  manageAvailability = false,
  onEnabledRolesChange,
}: OrgRolePermissionsSectionProps) {
  return (
    <div className="grid gap-0 divide-y divide-border lg:grid-cols-[minmax(240px,300px)_1fr] lg:divide-x lg:divide-y-0">
      <div className="pb-4 lg:pr-5 lg:pb-0">
        <OrgRoleListPanel
          enabledOrgRoles={enabledOrgRoles}
          rolePermissions={rolePermissions}
          selectedRoleKey={selectedRoleKey}
          onSelectRoleKey={onSelectRoleKey}
          manageAvailability={manageAvailability}
          onEnabledRolesChange={onEnabledRolesChange}
        />
      </div>
      <div className="pt-4 lg:pl-5 lg:pt-0">
        <OrgRolePermissionsPanel
          enabledOrgRoles={enabledOrgRoles}
          enabledApps={enabledApps}
          rolePermissions={rolePermissions}
          roleKey={selectedRoleKey}
          onChange={onChange}
          manageAvailability={manageAvailability}
        />
      </div>
    </div>
  );
}
